<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import UserTwoFactor from '../../../user/components/UserTwoFactor.vue'

definePage({
  meta: {
    requiresAuth: true,
    hideLeftColumn: true,
    hideRightColumn: true,
  },
})
</script>

<template>
  <UserTwoFactor />
</template>
